<template>
  <q-select
    :value="value"
    label="Selecione"
    option-label="name"
    option-value="id"
    filled
    :multiple="true"
    use-input
    emit-value
    :options="options"
    :loading="loading"
    @input="onChange"
    @filter="filterFn"
  >
    <template v-slot:selected>
      <catalog-name
        v-if="value"
        :id="value"
      />
    </template>
    <template
      v-slot:selected-item="scope"
    >
      <q-chip
        removable
        dense
        :tabindex="scope.tabindex"
        class="q-ma-none"
        @remove="scope.removeAtIndex(scope.index)"
      >
        <catalog-name
          :id="scope.opt"
        />
      </q-chip>
    </template>
  </q-select>
</template>

<script>
import CatalogName from '../CatalogName';

export default {
  name: 'CatalogPicker',
  components: {
    CatalogName,
  },
  props: {
    root: { type: String, default: '' },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      options: [],
      loading: false,
    };
  },
  watch: {
    root: {
      immediate: true,
      async handler(val, oldVal) {
        if (val === oldVal) {
          return;
        }
        this.loading = true;
        this.options = await this.$services.catalogsrest.getAllChildren(val);
        this.loading = false;
      },
    },
  },
  methods: {
    filterFn(val, update) {
      update(async () => {
        const resp = await this.$services.catalogsrest.searchGraph({
          page: 0,
          perPage: 50,
          term: val,
          parent: this.root,
        });

        this.options = resp.data.map(({ id, path_name: pathName }) => {
          const name = pathName.split('[??]').join(' / ');

          return {
            id,
            name,
          };
        });
      });
    },
    onChange(v) {
      this.$emit('input', v);
    },
  },
};
</script>
